import Column from '@components/Column';

import styles from './styles.module.scss';

function ReceiptDivider() {
  return (
        <Column fullWidth spacing={4} className={styles.divider}>
            <div className={styles.line} />
            <div className={styles.line} />
        </Column>
  );
}

export default ReceiptDivider;
